import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('fr-GN', {
    style: 'currency',
    currency: 'GNF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date));
}

export function validatePhone(phone) {
  // Format guinéen : XXXXXXXXX (9 chiffres, sans indicatif)
  const guineanPhoneRegex = /^[0-9]{9}$/;
  return guineanPhoneRegex.test(phone);
}

export function formatPhone(phone) {
  const cleaned = phone.replace(/\D/g, '');
  
  // Si commence par 224, retirer l'indicatif
  if (cleaned.startsWith('224') && cleaned.length === 12) {
    return cleaned.substring(3);
  }
  
  // Si 9 chiffres, retourner tel quel
  if (cleaned.length === 9) {
    return cleaned;
  }
  
  return cleaned;
}